import './App.css';
import AlbumsScreen from './screens/AlbumsScreen';
import HomeScreen from './screens/HomeScreen';
import MembersScreen from './screens/MembersScreen';
import LoreScreen from './screens/LoreScreen';
import Footer from './components/Footer/Footer';
import SteamTrail from './components/SteamTrail/SteamTrail';
import { MemberExpandedProvider } from './context/MemberExpandedContext';

function App() {
  return (
    <MemberExpandedProvider>
    <div>
      <SteamTrail active={true} />
      <section id="inicio">
        <HomeScreen />
      </section>
      <section id="members">
        <MembersScreen />
      </section>
      <section id="albuns">
        <AlbumsScreen />
      </section>
      <section id="lore">
        <LoreScreen />
      </section>
      <Footer />
    </div>
    </MemberExpandedProvider>
  );
}

export default App;